<template>
    <div style="padding: 20px;height: 100%;width: 100%;">
        <div class="title">
            <div style="display: flex;align-items: center">
                <img src="../../../assets/img/icon.png" alt="" style="width: 24px;margin:0px 5px">
                <h3>业务发展趋势</h3>
            </div>
            <div style="font-size: 14px">环比
                <img src="../../../assets/img/up.png" alt="" v-if="echartsData.ywfz_huanbi_jiajian==1">
                <img src="../../../assets/img/down.png" alt="" v-else>
                {{echartsData.ywfz_huanbi}}%
            </div>
            <div style="font-size: 14px">同比
                <img src="../../../assets/img/up.png" alt="" v-if="echartsData.ywfz_tongbi_jiajian==1">
                <img src="../../../assets/img/down.png" alt="" v-else>
                {{echartsData.ywfz_tongbi}}%
            </div>
        </div>
        <div class="brokenLine">
            <div id="main" style="width: 100%;height: 100%"></div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
export default {
    name: 'signTrend',
    props:['echartsData'],
    data(){
        return{
            charts: "",
            opinionData: [], // 数据
            month:[],
        }
    },
    methods: {
        drawLine(id) {
            // 初始化折线图
            this.charts = echarts.init(document.getElementById(id));

            // 设置折线图数据和样式
            this.charts.setOption({
                tooltip: {
                    trigger: "axis",
                },
                grid: {
                    lineStyle: {
                        type: 'dashed', // 设置网格线为虚线
                        dashArray: [5, 5]
                    },
                    borderWidth: 0, // 确保网格线的样式不会被默认边框样式覆盖
                    top: "15%",
                    left: "2%",
                    right: "10%",
                    bottom: "2%",
                    containLabel: true,
                },

                textStyle: {
                    color: "#ffffff",
                },
                // 自定义：设置x轴刻度
                xAxis: {
                    name:'月份',
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            type: 'dashed', // 设置为虚线
                        }
                    },
                    data: this.month
                },

                // 自定义：设置y轴刻度
                yAxis: {
                    name:'数量',
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: '#696A6F',
                            type: 'dashed' // 设置为虚线
                        }
                    },
                    offset: 10
                },

                // 设置数据
                series: [
                    {
                        type: "line",
                        stack: "总量", // 自定义
                        data: this.opinionData, // 自定义
                        symbolSize: 8,
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "#CD616D",
                                    },
                                    {
                                        offset: 1,
                                        color: '#20202A' // 结束颜色
                                    }
                                ],
                                global: false,
                            },
                        },
                        itemStyle: {
                            color: "#CD616D",
                            lineStyle: {
                                color: "#CD616D",
                                borderColor: '#fff', // 数据点边框颜色
                                borderWidth: 2 // 数据点边框宽度
                            },
                        },
                    },
                ],
            });
        },
    },
    watch: {
        echartsData: {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (!newVal) return;
                // 全量替换配置数据（触发响应式更新）
                if (newVal) {
                    this.$nextTick(() => {
                        this.opinionData  = newVal.ywfz_data_arr;
                        this.month  = newVal.yue_arr;
                        this.drawLine("main");
                    });
                }
            },
        },
    },
    mounted() {
        // this.drawLine("main");
    }
}
</script>

<style scoped lang="scss">
h3{
    --c: #008CFF;
    color: #acd3ec;
    text-shadow: 0 0 10px var(--c),
    //margin: 0px 0px 20px 10px;
}
.brokenLine{
    width: 100%;
    height: 80%;
}
.title{
    display: flex;
    align-items: center;
    div{
        margin-right: 20px;
    }
    img{
        width: 16px;
    }
}
</style>